import SkeletonInsuranceCard from './SkeletonInsuranceCard.jsx'
import InsuranceCard from './InsuranceCard.jsx'

export {InsuranceCard, SkeletonInsuranceCard}
